import NextLink from 'next/link';

import { Modal } from '@frontendmentorio/design-system-v2';

export default function JSModal({ modal }) {
  return (
    <Modal modal={modal}>
      <Modal.Heading>
        How does the JavaScript validation report work?
      </Modal.Heading>

      <p>
        When a solution is submitted, we use{' '}
        <NextLink
          className="underline hover:no-underline"
          href="https://eslint.org/"
        >
          eslint
        </NextLink>{' '}
        to run an automated check on the JavaScript code.
      </p>

      <p>
        The report picks out common JavaScript issues such as not using
        semicolons and using var instead of let or const, among others.
      </p>

      <p>
        The report will audit all JS and JSX files in your repository. We
        currently do not support Typescript or other frontend frameworks.
      </p>
    </Modal>
  );
}
